import { render, staticRenderFns } from "./TransportDashboard.vue?vue&type=template&id=283f5de8&scoped=true"
import script from "./TransportDashboard.vue?vue&type=script&lang=js"
export * from "./TransportDashboard.vue?vue&type=script&lang=js"
import style0 from "./TransportDashboard.vue?vue&type=style&index=0&id=283f5de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283f5de8",
  null
  
)

export default component.exports